/**
 * Which platform the app is running in.
 *
 * Telegram puts its launch parameters in the URL hash, which is also why the
 * router is a BrowserRouter and not a HashRouter.
 */
import { createBrowserPlatform } from './browser'
import { createTelegramPlatform, loadTelegramSdk } from './telegram'
import type { Platform } from './types'

export function looksLikeTelegram(): boolean {
  if (typeof window === 'undefined') return false
  if (window.Telegram?.WebApp?.initData) return true

  const hash = window.location.hash ?? ''
  const search = window.location.search ?? ''
  return hash.includes('tgWebAppData') || hash.includes('tgWebAppPlatform') || search.includes('tgWebAppStartParam')
}

export async function detectPlatform(): Promise<Platform> {
  if (!looksLikeTelegram()) {
    return createBrowserPlatform()
  }

  const webApp = await loadTelegramSdk()
  if (!webApp) {
    // Inside Telegram but the SDK did not load: the app still works as a page
    return createBrowserPlatform()
  }
  return createTelegramPlatform(webApp)
}
